// Self-contained types for the IHG Custom Buyer Briefs demo.
// Deliberately duplicated from the real Buyer Briefs V2 feature — this demo
// must not share any code with it.

export enum IhgBriefType {
    SUPPLIER = "supplier",
    CATEGORY_BENCHMARK = "category_benchmark",
}

export const IHG_BRIEF_TYPE_LABELS: Record<IhgBriefType, string> = {
    [IhgBriefType.SUPPLIER]: "Supplier",
    [IhgBriefType.CATEGORY_BENCHMARK]: "Category",
};

export enum IhgEvaluationGoal {
    NEW_SUPPLIER_EVALUATION = "new_supplier_evaluation",
    RENEWAL_DECISION = "renewal_decision",
    CONTRACT_NEGOTIATION_PREP = "contract_negotiation_prep",
    RISK_ASSESSMENT = "risk_assessment",
    COMPETITIVE_COMPARISON = "competitive_comparison",
    DUE_DILIGENCE = "due_diligence",
}

export const IHG_EVALUATION_GOAL_LABELS: Record<IhgEvaluationGoal, string> = {
    [IhgEvaluationGoal.NEW_SUPPLIER_EVALUATION]: "New Supplier Evaluation",
    [IhgEvaluationGoal.RENEWAL_DECISION]: "Renewal Decision",
    [IhgEvaluationGoal.CONTRACT_NEGOTIATION_PREP]: "Contract Negotiation Prep",
    [IhgEvaluationGoal.RISK_ASSESSMENT]: "Risk Assessment",
    [IhgEvaluationGoal.COMPETITIVE_COMPARISON]: "Competitive Comparison",
    [IhgEvaluationGoal.DUE_DILIGENCE]: "Due Diligence",
};

export enum IhgBriefStatus {
    PROCESSING = "processing",
    COMPLETED = "completed",
}

export const IHG_STATUS_LABELS: Record<IhgBriefStatus, string> = {
    [IhgBriefStatus.PROCESSING]: "Processing",
    [IhgBriefStatus.COMPLETED]: "Completed",
};

export enum IhgRegion {
    GLOBAL = "global",
    NORTH_AMERICA = "north_america",
    EMEA = "emea",
    APAC = "apac",
    GREATER_CHINA = "greater_china",
    LATAM = "latam",
}

export const IHG_REGION_LABELS: Record<IhgRegion, string> = {
    [IhgRegion.GLOBAL]: "Global",
    [IhgRegion.NORTH_AMERICA]: "North America",
    [IhgRegion.EMEA]: "EMEA",
    [IhgRegion.APAC]: "APAC",
    [IhgRegion.GREATER_CHINA]: "Greater China",
    [IhgRegion.LATAM]: "LATAM",
};

export const IHG_SPEND_BANDS = [
    "< €500K",
    "€500K – €1M",
    "€1M – €5M",
    "€2M – €10M",
    "€10M – €50M",
    "€50M+",
];

export interface IhgBrief {
    id: number;
    briefType: IhgBriefType;
    /** Supplier name, or category name for category benchmarks */
    subject: string;
    /** Display category shown in the list */
    category: string;
    /** Display goal shown in the list (e.g. "Category Benchmark") */
    goalLabel: string;
    status: IhgBriefStatus;
    /** e.g. "Yes" / "Conditional"; undefined renders as "—" */
    recommendation?: string;
    /** ISO date */
    createdAt: string;
    logoUrl?: string;
    /** Canned output; only seeded briefs have one — generated briefs never finish */
    briefHtml?: string;
}
